import { cn } from '@nucleus-commerce/ui/lib/utils';

export interface BrandMarkProps {
  /** Pixel size of the square mark. */
  size?: number;
  className?: string;
}

/** The Nucleus gem mark, drawn in the current primary colour. Decorative; pair it with a text label. */
export function BrandMark({ size = 24, className }: BrandMarkProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 28 28"
      fill="none"
      aria-hidden
      className={cn('text-primary shrink-0', className)}
    >
      <path
        d="M14 2 26 10 14 26 2 10Z"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
      <path
        d="M2 10h24M14 2 9 10l5 16 5-16-5-8"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeLinejoin="round"
      />
    </svg>
  );
}
